
export default function tagVariations(str) {
    let result = str;
    result = result.replace("bonus", `<span style="background: #f0ff00;padding: 3px;border-radius: 12px;">Pack</span>`)
    result = result.replace("kilo gramos regalo", `<span style="background: #f0ff00;padding: 3px;border-radius: 12px;">Bonus Bag</span>`);
    result = result.replace("regalo", `<span style="background: #f0ff00;padding: 3px;border-radius: 12px;">Con Regalo</span>`);
    result = result.replace("Unidades Combo", `<span style="background: #f0ff00;padding: 3px;border-radius: 12px;">Unidades Combo</span>`);
    return result;
}